import { EventTypes } from '../types';
import { buildMixpanelEvent } from './base';

const { pageView, applicationSubmit } = EventTypes;

export const MixpanelEvents = {
    [pageView]: buildMixpanelEvent(),
    [applicationSubmit]: buildMixpanelEvent(applicationSubmit),
};
